module.exports = __webpack_public_path__ + "img/28.a5fb18ce.jpg";